// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22AcI","label":"styles_label__2nNgB"};